const OP = {
  es: {
    home: {
      titulo: 'Tanta Restaurantes | Inicio',
      desc: 'Tanta es tu, sala, comedor o terraza. Celebramos en familia la cocina y su diversidad, sobre todo en la comida casera peruana, esa comida que nos han preparado nuestras madres y abuelas toda la vida.',
      link: 'http://tantaperu.com/'
    }
  },
  en: {
    home: {
      titulo: 'Tanta Restaurantes | Home',
      desc: 'Tanta is your living room, dinning room or terrace. We celebrate food and its diversity as a family, especially Peruvian home cooking, that prepared by our mothers and grandmothers.',
      link: 'http://tantaperu.com/en'
    }
  },
  img: {
    home: 'http://admin.tantaperu.com/wp-content/uploads/2019/09/tanta-fb.png',
  }
}

export default OP;